import {createActionCreator, Dispatch, ThunkActionCreator} from 'PyzShopUi/scripts/shop-ui/includes/enhanced-reducer';
import {ApiQueryData, ProductVariantActionState, ProductVariantItem, ProductVariantResponse} from '../interfaces';
import {productVariantService} from './product-variant-service';

const UPDATE_PRODUCT_VARIANT_STATE = 'UPDATE_PRODUCT_VARIANT_STATE';
const BEGIN_PRODUCT_VARIANT_PAGE_LOADING = 'BEGIN_PRODUCT_VARIANT_PAGE_LOADING';
const END_PRODUCT_VARIANT_PAGE_LOADING = 'END_PRODUCT_VARIANT_PAGE_LOADING';
export const updateProductVariantState = createActionCreator<ProductVariantActionState>(UPDATE_PRODUCT_VARIANT_STATE);
export const beginGetProductVariantLoading = createActionCreator(BEGIN_PRODUCT_VARIANT_PAGE_LOADING);
export const endGetProductVariantLoading = createActionCreator(END_PRODUCT_VARIANT_PAGE_LOADING);
export const initProductVariantState: ThunkActionCreator<ProductVariantActionState> = (
) => (dispatch, getState) => {

    const initState = getState();
    const apiQueryData: ApiQueryData = {
        ...initState.apiQueryData,
        ...productVariantService.getDefaultQueryObject()
    };

    doGetProductVariantData(dispatch, apiQueryData, []);
};

export const getProductVariant: ThunkActionCreator<ProductVariantActionState> = (
    data: ProductVariantResponse
) => (dispatch, getState) => {
    const initState = getState();
    const apiQueryData: ApiQueryData = {
        ...initState.apiQueryData,
        ...productVariantService.getDefaultQueryObject()
    };
    dispatch(beginGetProductVariantLoading());
    const productVariantState = buildProductVariantState(data, apiQueryData, []);
    dispatch(updateProductVariantState(productVariantState));
    dispatch(endGetProductVariantLoading());
};

export const getProductVariantData: ThunkActionCreator<ProductVariantActionState> = (
    apiQueryData: ApiQueryData
) => (dispatch, getState) => {
    const { productVariants } = getState();

    doGetProductVariantData(dispatch, apiQueryData, productVariants);
};

const doGetProductVariantData = (dispatch: Dispatch, apiQueryData: ApiQueryData, productVariants: ProductVariantItem[]) => {
    dispatch(beginGetProductVariantLoading());
    productVariantService.getData(apiQueryData).then((data: ProductVariantResponse) => {
        const productVariantState = buildProductVariantState(data, apiQueryData, productVariants);
        dispatch(updateProductVariantState(productVariantState));
        dispatch(endGetProductVariantLoading());
    }).catch(() => {
        dispatch(endGetProductVariantLoading());
    });
};

const buildProductVariantState = (
    data,
    currentApiQueryData: ApiQueryData,
    productVariants: ProductVariantItem[]
): ProductVariantActionState => {
    const responseVariants: ProductVariantItem[] = [...productVariants, ...data.variants] ;
    const currentPage = (data.current_page === 0) ? 1 : data.current_page;

    return {
        productVariants: responseVariants,
        isPageLoading: true,
        currentPage,
        maxPage: data.max_page,
        apiQueryData : currentApiQueryData
    };
};
